module.exports = __webpack_public_path__ + "img/check.eb87a054.svg";